import axios from "axios";
import store from '@/store';
import {message} from "./resetMessage";
import router from "@/router";
import { getPublicKey, getLoginUsersId, getLoginUsersToken } from '@/utils/auth'
import { getProductionApiBaseUrl } from '@/utils/apiUrl'
import Cookies from 'js-cookie';
// create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/api" : getProductionApiBaseUrl(),
  timeout: 300*1000 // request timeout
});
// request拦截器
service.interceptors.request.use(
  config => {
    //设置header
    const PublicKey = Cookies.get('PublicKey');
    const LoginUsersId = Cookies.get('LoginUsersId');
    const LoginUsersToken = Cookies.get('LoginUsersToken');
    if(PublicKey) {
      config.headers['Public-key'] = PublicKey
    } else {
      config.headers['Public-key'] = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDy8oXwkKZRB7AuSpN55qZnUXZzgAQnD1FtiyD-BqI3-U5oJUo8ASPpMZBjl9M1h4HITEO7V6x-Q3ErOe1z7VZFIm6hm2OeMK46vT9wG7TPBeL0NBRM1e0_YSWLStHRUsG4DGgD4w5e0xjnAmzq7xJYrs51AwJz7mpBYNOLV1CR5QIDAQAB'
    }
    if(LoginUsersToken) {
      config.headers['Login-users-token'] = LoginUsersToken
    }
    if(LoginUsersId) {
      config.headers['Login-users-id'] = LoginUsersId
    }
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);
// response interceptor
service.interceptors.response.use(
  response => {

    const res = response.data;
    if (res.code === 10200 || res.state === 10200 ||res.state === 10331 ) {
      return res;
    } else {
      if (!response.config.silent && res.state != 10310 && res.state != 10311 && res.state != 10311) {
        message.error({
          message: res.message,
          duration: 2 * 1000,
          dangerouslyUseHTMLString: true,
          // duration: 10 * 1000,
          offset: 200,
          showClose: true
        });
      }
      if (res.state === 10300) {
        router.replace("/");
      } else if (res.state === 10301) {
        store.commit('logout')
        router.replace("/");
      }
    }

    return Promise.reject(res);
  },
  error => {
    if (!error.config || !error.config.silent) {
      message.error({
        message: error.message,
        dangerouslyUseHTMLString: true,
        showClose: true,
        duration: 2 * 1000,
        offset: 200
      });
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js